// Sidebar Routers
export const menus = {
    'message.mainMenu': [
        {
            title: 'message.dashboard',
            active: true,
            path: '/dashboard',
            items: null,
            exact: true
        },
        {
            title: 'message.caseSearch',
            active: false,
            path: '/casesearch',
            items: null,
            exact: true
        },
        {
            title: 'message.reports',
            active: false,
            path: '/reports',
            items: null,
            exact: true
        },
        {
            title: 'message.administration',
            active: false,
            items: [
                { title: 'message.letterTemplates', path: '/lettertemplates', exact: true },
                { title: 'message.userAdmin', path: '/useradministration', exact: true }
            ]
        }
    ]
}
